export const getSubscriptionState = ({ subscription }) => (
  subscription.get('subscription').get('state')
)

export const getShouldClosePauseReasonsView = ({ onScreenRecovery }) => onScreenRecovery.get('modalType') === 'subscription' && onScreenRecovery.get('triggered') === true
